import { Button } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Trash } from '../../../icons/trash';
import STRING_KEYS from '../../../language/keys';

type DeleteAccountButtonProps = {
  onDeleteClick: () => void,
  isDisable?: boolean,
}
export const DeleteAccountButton = ({
  onDeleteClick,
  isDisable,
}:DeleteAccountButtonProps):JSX.Element => {
  const { t: translate } = useTranslation();

  return (
    <Button
      variant="text"
      color="error"
      onClick={ onDeleteClick }
      disabled={ isDisable }
      startIcon={
        <Trash />
      }
    >
      {translate(STRING_KEYS.DELETE_ACCOUNT)}
    </Button>
  );
};

DeleteAccountButton.defaultProps = {
  isDisable: false,
};
